import styled from 'styled-components';
const MediaWrapper = styled.div.withConfig({
  displayName: "MediaWrapper"
})(["position:relative;border-radius:", ";overflow:hidden;border:1px solid ", ";"], ({
  theme
}) => theme.spotlight.borderRadius.sm, ({
  theme
}) => theme.spotlight.color.border);
MediaWrapper.displayName = 'MediaWrapper';
export default MediaWrapper;